import { ComponentType, ReactElement, useContext } from "react";

import clsx from "clsx";

import { HFlex } from "src/components";
import { LoginContext } from "src/core/loginContext";
import { CandidateMode } from "src/utils/api/configD";

import { ReviewConfiguration } from "./ReviewConfiguration";
import { SwitchToEdit } from "./SwitchToEdit";
import { ButtonProps } from "./types";
import { ViewRunning } from "./ViewRunning";

import "./ActionsToolbar.scss";
interface ActionsToolbarProps {
  readonly PreviewButton: ComponentType<ButtonProps>;
  readonly mode: CandidateMode;
  readonly setMode: (m: CandidateMode) => void;
  readonly onPreviewChanges?: () => void;
  readonly onReviewConfiguration?: () => void;
  readonly previewChangesDrawer?: ReactElement | null;
}

/**
 * Generic candidate actions component that can be used for any candidate type
 */
export const ActionsToolbar = ({
  mode,
  setMode,
  PreviewButton,
  onPreviewChanges,
  onReviewConfiguration,
  previewChangesDrawer
}: ActionsToolbarProps) => {
  const { isReadOnly } = useContext(LoginContext);

  // force RO users do not show any of the actions
  if (isReadOnly) {
    return null;
  }

  return (
    <HFlex gap="xs" className="action-section" align="center" justify="start">
      <HFlex
        show={mode === CandidateMode.Edit}
        className="action-candidate-buttons"
        gap="sm"
      >
        <PreviewButton handleAction={onPreviewChanges} />
        <ReviewConfiguration handleAction={onReviewConfiguration} />
      </HFlex>
      <div
        className={clsx("divider", { hidden: mode === CandidateMode.Running })}
      />
      <SwitchToEdit
        show={mode === CandidateMode.Running}
        handleAction={() => setMode(CandidateMode.Edit)}
      />
      <ViewRunning
        show={mode === CandidateMode.Edit}
        handleAction={() => setMode(CandidateMode.Running)}
      />
      {previewChangesDrawer}
    </HFlex>
  );
};
